import { createStore } from "vuex";
import user, { UserState } from "@/store/modules/user";

export interface RootState {
  user: UserState;
}

export default createStore<RootState>({
  modules: {
    user,
  },
});
